export default __webpack_public_path__ + "static/media/pbanner.c88b28f8.gif";